/** Default item-specifics layout used by the listing optimizer process. */
export const DEFAULT_ITEM_SPECS_CONFIG = {
  defaults: [
    {
      name: 'Brand',
      values: ['Rev & Bolt'],
    },
    {
      name: 'Aniticipated Ship Out Time',
      values: ['1-3 Business Days'],
      matchNames: ['Anticipated Ship Out Time', 'Aniticipated Ship Out Time'],
    },
    {
      name: 'Returns Policy',
      values: ['30 Day Return Policy'],
    },
  ],
  orderedAfterDefaults: [
    { name: 'Material' },
    { name: 'Finish' },
    { name: 'Part Name' },
    { name: 'Type' },
    {
      name: 'Partslink Number',
      matchNames: ['Partslink Number', 'Part Link Number'],
    },
    { name: 'OE Number' },
    { name: 'Placement on Vehicle' },
    { name: 'Fitment Type' },
    { name: 'Universal Fitment' },
    { name: 'Quantity' },
  ],
  endingOrdered: [
    { name: 'OE/OEM Part Number' },
    { name: 'Other Part Number' },
    { name: 'Interchange Part Number' },
    { name: 'Superseded Part Number' },
  ],
  excluded: [{ name: 'California Prop 65 Warning' }],
};

export const VERIFIED_EBAY_SELLER = {
  username: 'carpartswholesale',
  label: 'Car Parts Wholesale',
  description:
    'Listing optimizer fetches verified item specifics and fitment from this eBay seller account.',
};
